import { Component } from '@angular/core';

@Component({
  selector: 'ui-buttons',
  templateUrl: './buttons.component.html'
})
export class ButtonsComponent {
}